import $ from "jquery";
import siteNav from "./siteNav";

export default {
	init(enebleCloseMenuByScroll) {
		//const $element = $("#site_header");
		const $subMenuContainer = $("#nav_area").find(".menu-item-has-children");
		
		if($subMenuContainer.length) {
			const toggleOpen = e => {
				const $parent = $(e.currentTarget).parent();
				$parent.toggleClass("is-open");
				return false;
			};
			
			$subMenuContainer.each((i, elm) => {
				$(elm).children("a").eq(0).on("click", toggleOpen);
			});
		}
		
		siteNav.init(enebleCloseMenuByScroll);
	}
};
